import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";

// app header
import AppHeader from "../components/AppHeader/AppHeader";

// seo
import Seo from "../components/Seo";

// hook
import { useBookPackQuery } from "../hooks/useBookPackQuery";
import { useWindowSize } from "../hooks/useWindowSize";

// constant
import constant from "../constants";

// utils
import { splitName, splitPlanCodeBookPack } from "../utils";

// images
import bannerImg from "../images/bookPack/banner-new.png";

// services
import { sendToCT } from "../services/Clevertap";
import { sendToLSQ } from "../services/LeadSquared";
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";

// email
import { sendEmailNotifecation } from "../services/SendEmail";

// components
import Banner from "../components/Banner";
import BookPackPilotForm from "../components/BookPack/BookPackPilotForm";
import OtpModal from "../components/BookPack/OtpModal";
import FaqComponent from "../components/Home/Faq/Faq";
import CarouselV2 from "../components/Carousel/CarouselV2";

// api actions
import {
  handlePaymentOfBookPack,
  initiateSession,
} from "../actions/bookPackActions";

const WbdtCarePlan = ({ location, bookPack, windowSize }) => {
  const [otpModal, setOtpModal] = useState({
    show: false,
    mobileNumber: "",
    pendingPaymentBody: null,
    pendingLsqParams: null,
  });

  const [state, setState] = useState({
    loading: false,
    serverError: "",
    type: "DIRECT_M2_ANNUAL",
    planCode: "",
    planPrice: 0,
    coupon: "",
    couponApplied: false,
    couponStatus: "",
    clintInfo: {},
    annualPlanPrice: 0,
    selectedPlan: "annualPlan",
    productId: "",
    installmentPlanPrice: 0,
    firstInstallmentPrice: 0,
    quarterlyPlanPrice: 0,
    monthlyPlanPrice: 0,
    toggleButtonValue: "pilot_diabetes",
    medicalDisorderType: "DIABETES",
    annualOfferPrice: 0,
    installmentOfferPrice: 0,
    quarterlyOfferPrice: 0,
    monthlyOfferPrice: 0,
  });

  const formSectionRef = useRef(null);

  // Initialize component
  useEffect(() => {
    const annualPlan = bookPack.pilot_diabetes.annualPlan[0];
    const installmentPlan = bookPack.pilot_diabetes.installmentPlan[0];
    const quarterlyPlan = bookPack.pilot_diabetes.quarterlyPlan[0];
    const monthlyPlan = bookPack.pilot_diabetes.monthlyPlan[0];

    let plan = null;
    if (state.selectedPlan === "installmentPlan") {
      plan = installmentPlan;
    } else if (state.selectedPlan === "quarterlyPlan") {
      plan = quarterlyPlan;
    } else if (state.selectedPlan === "monthlyPlan") {
      plan = monthlyPlan;
    } else {
      plan = annualPlan;
    }

    const annualPlanData = splitPlanCodeBookPack(annualPlan);
    const installmentPlanData = splitPlanCodeBookPack(installmentPlan);
    const quarterlyPlanData = splitPlanCodeBookPack(quarterlyPlan);
    const monthlyPlanData = splitPlanCodeBookPack(monthlyPlan);

    if (plan) {
      setState(prev => ({
        ...prev,
        planCode: annualPlanData[0],
        planPrice: Number(annualPlanData[1]),
        planDay: plan.planDay,
        productId: plan.productId,
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentPlanData[1]),
        firstInstallmentPrice: Number(installmentPlanData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        annualOfferPrice: Number(
          bookPack.pilot_diabetes.annualPlan[0].offerPrice
        ),
        installmentOfferPrice: Number(
          bookPack.pilot_diabetes.installmentPlan[0].offerPrice
        ),
        quarterlyOfferPrice: Number(
          bookPack.pilot_diabetes.quarterlyPlan[0].offerPrice
        ),
        monthlyOfferPrice: Number(
          bookPack.pilot_diabetes.monthlyPlan[0].offerPrice
        ),
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Proceed to payment after session is established
  const proceedToPayment = async paymentBody => {
    try {
      const response = await handlePaymentOfBookPack(paymentBody);
      const paymentUrl = response.results[0].url;
      setState(prev => ({ ...prev, loading: false }));
      window.location.href = paymentUrl;

      sendToCT("Enrollment Initiated", {
        action: "BookPack_Buy_Now Clicked",
        name: `${paymentBody.firstName} ${paymentBody.lastName}`,
        phone: paymentBody.mobileNumber,
        email: paymentBody.email,
        coupon: state.coupon,
        paymentPlan: state.planCode,
      });
    } catch (error) {
      sendEmailNotifecation(
        window.location.href,
        paymentBody,
        error || {},
        "/marketing/v3/prospect"
      );
      console.error("payment api server error", error);
      setState(prev => ({
        ...prev,
        loading: false,
        serverError: constant.BOOKPACK_ERROR_MESSAGES.serverError,
      }));
    }
  };

  // Handle payment
  const handlePayNow = async values => {
    const languageArr = [];
    const languageDisplayArr = [];
    if (values.language && values.language !== "") {
      values.language.forEach(item => {
        languageArr.push(item.name);
        languageDisplayArr.push(item.display);
      });
    }

    const { firstName, lastName } = splitName(values.name);
    const lsqParams = {
      FirstName: firstName,
      LastName: lastName,
      Phone: values.phone,
      EmailAddress: values.email,
      mx_Website_CTA: "book_pack_pilot",
      mx_Latest_Source: "New Website",
      mx_Language: languageDisplayArr.join(", "),
    };

    let subscriptionType = "";
    if (state.selectedPlan === "annualPlan") {
      subscriptionType = "YEARLY";
    } else if (state.selectedPlan === "installmentPlan") {
      subscriptionType = "HALF_YEARLY";
    } else if (state.selectedPlan === "quarterlyPlan") {
      subscriptionType = "QUARTERLY";
    } else if (state.selectedPlan === "monthlyPlan") {
      subscriptionType = "MONTHLY";
    }

    const paymentBody = {
      firstName,
      lastName,
      mobileNumber: values.phone,
      email: values.email,
      planCode: state.planCode,
      preferredM2Plan: state.type,
      m1PlanCode: state.planCode,
      m2PlanCode: state.planCode,
      sourceType: "DIGITAL_ORGANIC_TW",
      couponCode: state.coupon ? state.coupon.toUpperCase() : "",
      languageList: languageArr,
      medicalDisorderType: state.medicalDisorderType,
      subscriptionType,
      address: {
        postalCode: values.pinCode ? values.pinCode : "",
        city: values.city,
        line1: "",
      },
    };

    try {
      setState(prev => ({ ...prev, loading: true, serverError: "" }));

      const sessionResult = await initiateSession(lsqParams, values.phone);

      if (sessionResult.leadFound) {
        setState(prev => ({ ...prev, loading: false }));
        setOtpModal({
          show: true,
          mobileNumber: values.phone,
          pendingPaymentBody: paymentBody,
          pendingLsqParams: lsqParams,
        });
        return;
      }

      // Fresh lead — backend already created lead in LSQ, proceed directly
      await proceedToPayment(paymentBody);
    } catch (error) {
      console.error("initiate session error", error);
      setState(prev => ({
        ...prev,
        loading: false,
        serverError: constant.BOOKPACK_ERROR_MESSAGES.serverError,
      }));
    }
  };

  // Called by OtpModal after successful OTP verification
  const handleOtpVerified = async sessionToken => {
    setOtpModal(prev => ({ ...prev, show: false }));
    setState(prev => ({ ...prev, loading: true, serverError: "" }));
    try {
      await sendToLSQ({
        ...otpModal.pendingLsqParams,
        mx_OTP_Verified: "True",
      });
    } catch (e) {
      console.error("[handleOtpVerified] LSQ update failed:", e.message);
    }
    await proceedToPayment(otpModal.pendingPaymentBody);
  };

  // Resend OTP — re-calls initiate with stored params
  const handleOtpResend = async () => {
    if (otpModal.pendingLsqParams && otpModal.mobileNumber) {
      await initiateSession(otpModal.pendingLsqParams, otpModal.mobileNumber);
    }
  };

  // Handle coupon update
  const handleCouponUpdate = (planPrice, coupon, discountAmt) => {
    if (coupon) {
      setState(prev => ({
        ...prev,
        showConfetti: true,
        planPrice: Number(planPrice),
        coupon: coupon,
        couponApplied: true,
      }));

      // Update plan price of selected plan after coupon applied
      if (state.selectedPlan === "installmentPlan") {
        setState(prev => ({
          ...prev,
          installmentPlanPrice: Number(planPrice),
          firstInstallmentPrice:
            Number(state.firstInstallmentPrice) - Number(discountAmt),
        }));
      } else if (state.selectedPlan === "quarterlyPlan") {
        setState(prev => ({ ...prev, quarterlyPlanPrice: Number(planPrice) }));
      } else if (state.selectedPlan === "monthlyPlan") {
        setState(prev => ({ ...prev, monthlyPlanPrice: Number(planPrice) }));
      } else {
        setState(prev => ({ ...prev, annualPlanPrice: Number(planPrice) }));
      }

      setTimeout(() => {
        setState(prev => ({ ...prev, showConfetti: false }));
      }, 5000);
    }
  };

  // Remove coupon
  const removedCoupon = () => {
    const annualPlanData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].annualPlan[0]
    );
    const installmentData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].installmentPlan[0]
    );
    const quarterlyPlanData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].quarterlyPlan[0]
    );
    const monthlyPlanData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].monthlyPlan[0]
    );

    if (state.selectedPlan === "installmentPlan") {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
      }));
    } else if (state.selectedPlan === "quarterlyPlan") {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
      }));
    } else if (state.selectedPlan === "monthlyPlan") {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        monthlyPlanPrice: Number(monthlyPlanData[1]),
      }));
    } else {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
      }));
    }
  };

  // Handle plan selection
  const handlePlan = val => {
    const annualPlanData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].annualPlan[0]
    );
    const installmentData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].installmentPlan[0]
    );
    const quarterlyPlanData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].quarterlyPlan[0]
    );
    const monthlyPlanData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue].monthlyPlan[0]
    );
    const selectedPlanData = splitPlanCodeBookPack(
      bookPack[state.toggleButtonValue][val][0]
    );

    let planCode = "";
    let planPrice = "";

    if (val === "installmentPlan") {
      planCode = installmentData[0];
      planPrice = Number(installmentData[1]);
    } else if (val === "quarterlyPlan") {
      planCode = quarterlyPlanData[0];
      planPrice = Number(quarterlyPlanData[1]);
    } else if (val === "monthlyPlan") {
      planCode = monthlyPlanData[0];
      planPrice = Number(monthlyPlanData[1]);
    } else {
      planCode = annualPlanData[0];
      planPrice = Number(annualPlanData[1]);
    }

    setState(prev => ({
      ...prev,
      selectedPlan: val,
      planCode: planCode,
      planPrice: planPrice,
      firstInstallmentPrice: Number(installmentData[2]),
    }));

    // Reset coupon when plan changes
    if (state.couponApplied === true && val === "annualPlan") {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        planCode: selectedPlanData[0],
      }));
    } else if (state.couponApplied === true && val === "installmentPlan") {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        planCode: selectedPlanData[0],
      }));
    } else if (state.couponApplied === true && val === "quarterlyPlan") {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        planCode: selectedPlanData[0],
      }));
    } else {
      setState(prev => ({
        ...prev,
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        planCode: selectedPlanData[0],
      }));
    }
  };

  // Handle toggle button
  const handleToggleButton = value => {
    const toggleConfig = {
      pilot_diabetes: "DIABETES",
      pilot_obesity: "OBESITY",
      pilot_pre_diabetes: "PRE_DIABETES",
      pilot_metabolic_wellness: "METABOLIC_WELLNESS",
      pilot_pcos: "PCOS",
      pilot_hypertension: "HYPERTENSION",
      pilot_fatty_liver: "FATTY_LIVER",
    };

    const medicalDisorderType = toggleConfig[value] || "DIABETES";
    const planData = bookPack[value];

    const annualPlanData = splitPlanCodeBookPack(planData.annualPlan[0]);
    const installmentPlanData = splitPlanCodeBookPack(
      planData.installmentPlan[0]
    );
    const quarterlyPlanData = splitPlanCodeBookPack(planData.quarterlyPlan[0]);
    const monthlyPlanData = splitPlanCodeBookPack(planData.monthlyPlan[0]);

    setState(prev => ({
      ...prev,
      planCode: annualPlanData[0],
      planPrice: Number(annualPlanData[1]),
      annualPlanPrice: Number(annualPlanData[1]),
      installmentPlanPrice: Number(installmentPlanData[1]),
      firstInstallmentPrice: Number(installmentPlanData[2]),
      quarterlyPlanPrice: Number(quarterlyPlanData[1]),
      monthlyPlanPrice: Number(monthlyPlanData[1]),
      toggleButtonValue: value,
      selectedPlan: "annualPlan",
      medicalDisorderType: medicalDisorderType,
      coupon: "",
      couponApplied: false,
      annualOfferPrice: Number(planData.annualPlan[0].offerPrice),
      installmentOfferPrice: Number(planData.installmentPlan[0].offerPrice),
      quarterlyOfferPrice: Number(planData.quarterlyPlan[0].offerPrice),
      monthlyOfferPrice: Number(planData.monthlyPlan[0].offerPrice),
    }));
  };

  // Mixpanel CTA tracking
  const handleMixpanelCTA = (ctaText, ctaLocation) => {
    Mixpanel.track(MixpanelEvents.contact_button_clicked, {
      page_name: "Enroll Now Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      cta_text: ctaText,
      cta_location: ctaLocation,
    });
  };

  // Mixpanel FAQ tracking
  const handleMixpanelCTAFaq = (faqText, faqDesc) => {
    Mixpanel.track(MixpanelEvents.faq_clicked, {
      page_name: "Enroll Now Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      faq_text: faqText,
      faq_desc: faqDesc,
      faq_location: "Enroll Now Page - FAQ Clicked",
    });
  };

  // Scroll to form section
  const scrollToForm = () => {
    if (formSectionRef.current) {
      formSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const { appHeader } = queryString.parse(location.search);

  return (
    <div>
      <OtpModal
        show={otpModal.show}
        mobileNumber={otpModal.mobileNumber}
        onVerified={handleOtpVerified}
        onClose={() => setOtpModal(prev => ({ ...prev, show: false }))}
        onResend={handleOtpResend}
      />
      <Seo
        title="Your Twin Health Care Plan | Reclaim Your Energy"
        description="A personalised, doctor-led plan to reverse diabetes, obesity, PMOS, BP and fatty liver. Join Now! Take control of your health."
      />

      {appHeader === "mobile" && <AppHeader text="BOOK PACK" isBack={true} />}

      <Banner
        pageName="Join Program"
        title="Take Control of Your Health"
        description="Achieve Remission - Diabetes / Obesity / PMOS/ BP & More. Reclaim your energy, enjoy life more"
        ctaText="Enroll Now"
        ctaLink=""
        bannerImage={bannerImg}
        imageWidth="614px"
        imageHeight="566px"
        onCtaClick={() => {
          handleMixpanelCTA("Enroll Now", "Enroll Now Page - Banner Section");
          scrollToForm();
        }}
      />

      <BookPackPilotForm
        price={state.planPrice}
        handlePayNow={handlePayNow}
        loading={state.loading}
        handleCouponUpdate={handleCouponUpdate}
        coupon={state.coupon}
        removedCoupon={removedCoupon}
        selectedPlan={state.selectedPlan}
        name={state.clintInfo.name}
        email={state.clintInfo.email}
        phone={state.clintInfo.phone}
        postalCode={state.clintInfo.postalCode}
        locationSearch={location.search}
        productId={state.productId}
        annualPlanPrice={state.annualPlanPrice}
        planDay={state.planDay}
        showCouponSection={true}
        windowSize={windowSize}
        couponType="bookpackCoupon"
        leadSquaredParam="book_pack_pilot"
        handlePlan={handlePlan}
        installmentPlanPrice={state.installmentPlanPrice}
        firstInstallmentPrice={state.firstInstallmentPrice}
        handleToggleButton={handleToggleButton}
        toggleButtonValue={state.toggleButtonValue}
        quarterlyPlanPrice={state.quarterlyPlanPrice}
        monthlyPlanPrice={state.monthlyPlanPrice}
        annualOfferPrice={state.annualOfferPrice}
        installmentOfferPrice={state.installmentOfferPrice}
        quarterlyOfferPrice={state.quarterlyOfferPrice}
        monthlyOfferPrice={state.monthlyOfferPrice}
        couponMessageType="default"
        showAnnualCard={true}
        showInstallmentCard={false}
        showQuarterly={true}
        showMonthly={false}
        ref={formSectionRef}
      />

      <div className="bgGrayColor text-center text-danger">
        {state.serverError} &nbsp;
      </div>

      <CarouselV2
        items={constant.ENROLL_PAGE_TESTIMONIALS}
        slidesToShow={2}
        slidesToShowMobile={1}
        gap={24}
        autoPlay={true}
        autoPlayInterval={4000}
        showArrows={true}
        showCounter={true}
      />

      <FaqComponent
        title="Frequently Asked Questions"
        accordionPayload={constant.ENROLL_NOW_PAGE_FAQ}
        onCtaClick={(faqText, faqDesc) =>
          handleMixpanelCTAFaq(faqText, faqDesc)
        }
      />
    </div>
  );
};

const WithContext = props => {
  const bookPackPayloadDiabetes = useBookPackQuery("pilot_diabetes");
  const bookPackPayloadObesity = useBookPackQuery("pilot_obesity");
  const bookPackPayloadPreDiabetes = useBookPackQuery("pilot_pre_diabetes");
  const bookPackPayloadMetabolicWellness = useBookPackQuery(
    "pilot_metabolic_wellness"
  );
  const bookPackPayloadPCOS = useBookPackQuery("pilot_pcos");
  const bookPackPayloadHypertension = useBookPackQuery("pilot_hypertension");
  const bookPackPayloadFattyLiver = useBookPackQuery("pilot_fatty_liver");
  const windowSize = useWindowSize();

  const finalBookPackPayload = {
    pilot_diabetes: bookPackPayloadDiabetes,
    pilot_obesity: bookPackPayloadObesity,
    pilot_pre_diabetes: bookPackPayloadPreDiabetes,
    pilot_metabolic_wellness: bookPackPayloadMetabolicWellness,
    pilot_pcos: bookPackPayloadPCOS,
    pilot_hypertension: bookPackPayloadHypertension,
    pilot_fatty_liver: bookPackPayloadFattyLiver,
  };

  return (
    <WbdtCarePlan
      {...props}
      bookPack={finalBookPackPayload}
      windowSize={windowSize}
    />
  );
};

export default WithContext;
